// extracted by mini-css-extract-plugin
module.exports = {"embed-code":"EmbedCode_embed-code__hCT9h"};